import React, { memo } from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { UiButton } from '@shared/ui/UiButton';

import cls from './MainInformation.module.css';
import { useMainInformation } from './useMainInformation';
import { Icon } from '../../../../../../components/newUI/Icon/Icon';
import { InformationRow } from '../../UI/InformationRow/InformationRow';

interface MainInformationProps {
    classes?: string;
}

export const MainInformation = memo(({ classes }: MainInformationProps) => {
    const { values, needBlur, is_customer, onClickAddInfo, can_show_financial_info } =
        useMainInformation();

    const { t } = useTranslation();
    return (
        <div className={classNames(cls.MainInformation, [classes])}>
            {needBlur && !is_customer ? (
                <div className={cls.emptyMainInformationWrapper}>
                    <div className={cls.emptyVisualizationContent}>
                        <span>
                            {t('MainInformation.return.emptyMessage.part1')}
                            <br />
                            {t('MainInformation.return.emptyMessage.part2')}
                        </span>
                        {can_show_financial_info && (
                            <UiButton
                                onClick={onClickAddInfo}
                                startIcon={<Icon iconName="whitePlus" />}
                                btnText={t('MainInformation.return.addButton')}
                            />
                        )}
                    </div>
                </div>
            ) : (
                values.map((information) => (
                    <InformationRow
                        title={information.title}
                        key={information.title}
                        text={information.text}
                    />
                ))
            )}
        </div>
    );
});
